import './Loader.styles.scss'
import { DonationFormSkeletonLoader } from '@percent/hosted-donation-gateway/app/DonationForm/DonationFormSkeletonLoader/DonationFormSkeletonLoader'

export function InitialLoader() {
  return (
    <div className="layout" data-testid="initial-loader">
      <div className="loader-wrapper">
        <DonationFormSkeletonLoader />
      </div>
    </div>
  )
}
